import { Component, Element, Prop, h } from '@stencil/core';

import { InProgressVehicle } from '../../../interfaces/interface.vehicle';
import { defaultInProgressVehicleState } from '../../../utils/utils.vehicle';
import { VehicleDetailsModal } from '../vehicle-details-modal/vehicle-details-modal';
@Component({
  tag: 'offer-certificate-inprogress',
  styleUrl: 'offer-certificate-inprogress.css',
})
export class OfferCertificateInProgress {
  @Element() el: HTMLElement;
  @Prop() customer = { email: '', firstName: '', lastName: '', phone: '', zip: '' };
  @Prop() prospectId: string = '';
  @Prop() vehicle: InProgressVehicle = defaultInProgressVehicleState;
  @Prop() inProgressBtnText: string = '';
  @Prop() onFireDREvent: (buttonLabel?: string) => void = () => {};

  closeModal() {
    this.el.querySelector('ico-modal').close();
  }

  showVehicleDetailDialog(evt) {
    evt.preventDefault();
    const modal = this.el.querySelector('ico-modal#offer-details') as HTMLIcoModalElement;
    modal.open();
  }

  render() {
    const { email, zip } = this.customer;
    const vehicleName = this.vehicle.description.vehicle;

    return (
      <certificate-layout>
        <offer-inprogress
          prospectId={this.prospectId}
          email={email}
          zipCode={zip}
          vehicleShortDescription={vehicleName}
          whenReviewVehicleDetailsClicked={this.showVehicleDetailDialog.bind(this)}
          inProgressBtnText={this.inProgressBtnText}
          onFireDREvent={this.onFireDREvent}
        />
        <VehicleDetailsModal customer={this.customer} vehicle={this.vehicle} />
        <offer-certificate-disclaimer />
      </certificate-layout>
    );
  }
}
